export default "__VITE_ASSET__ZsINpJL3__"